module.exports = __webpack_public_path__ + "img/logoapunto.26c009e9.png";